interface ApiErrorObj {
    status: string;
    title: string;
    detail: any;
  }
  
interface ApiRespObj {
    errors: ApiErrorObj;
}
  
class ServerError extends Error {
    status: string;
  
    title: string;
  
    detail: string;
  
    constructor(responseObj: ApiRespObj) {
      super();
  
      const errors = responseObj?.errors || ({} as ApiErrorObj);
      const { status, title, detail } = errors;
  
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, ServerError);
      }
  
      this.status = String(status ?? "");
      this.title = String(title ?? "");
      this.detail = String(detail ?? "");
    }
  
    toJson() {
      return {
        status: this.status,
        title: this.title,
        detail: this.detail,
      };
    }
}

export default ServerError;
  
